import Button from "Components/Button/Button";

export default Button;
